import { useHistory } from 'react-router-dom';
import { useApplicationContext } from './Context';

export const useAppNavigation: () => {
  push: (to: string) => void;
  replace: (to: string) => void;
  goBack: () => void;
} = () => {
  const history = useHistory();
  let { urlBasePath } = useApplicationContext();
  if (urlBasePath.endsWith('/')) {
    urlBasePath = urlBasePath.slice(0, -1);
  }
  return {
    push: (to: string) =>
      history.push(`${urlBasePath}${to.startsWith('/') ? '' : '/'}${to}`),
    replace: (to: string) =>
      history.replace(`${urlBasePath}${to.startsWith('/') ? '' : '/'}${to}`),
    goBack: () => history.goBack(),
  };
};
